var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 37,
    viewBox: "0 0 139 37",
    width: 139,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 26.759,
    x2: -0.927623,
    y1: 3.24782,
    y2: 30.9344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ff1b43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#be0000"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6895,
    x2: 27.1272,
    y1: 17.9723,
    y2: 17.9723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 19.5186,
    x2: 22.5136,
    y1: 29.1016,
    y2: 29.1016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.8469 17.1532c1.0811-1.6702 1.6273-3.7602 1.6273-6.2338 0-10.9194-10.064-10.9194-13.357-10.9194-.817 0-1.95.074481-3.1598.153476-.7786.051911-1.5799.103822-2.1735.124135l-10.7839-.121878v10.203867h2.97924v24.4817l2.89573.4514c1.21878.1896 2.9183.3701 4.65393.4943l1.2278.0993h.0519c1.4084.0858 2.6655.1286 3.8369.1286h1.0428 1.0246c.7359.0066 1.4715-.0311 2.2029-.1128 1.7824-.2482 3.5034-.8245 5.076-1.6995 3.5796-2.011 5.5499-5.3469 5.5499-9.3937.0068-3.1688-.9028-5.7485-2.6948-7.6557zm-13.603-7.0757c.571-.0226 1.0766-.0361 1.458-.0361 2.6069 0 2.6069 0 2.6069 1.3384 0 1.0089-.1512 1.1511-.1806 1.1691-.3972.2438-1.8846.2438-2.5978.2438h-1.291zm4.2229 15.7651c-.5959.1558-1.4896.1558-2.3924.1558h-.2032c-.5439 0-1.1059 0-1.6498-.0361v-3.0808h1.3293c3.6586 0 3.6586.3001 3.6586 1.5595.0045.711-.4762 1.2888-.7425 1.4016z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.8932 17.5818c1.2707-.4898 4.1506-1.5641 4.1506-6.6649 0-6.8613-5.1911-7.49551-9.9308-7.49551-1.2458 0-3.9384.2257-5.4168.27986v3.1598c1.0405-.09028 3.5661-.24149 5.006-.24149 2.9341 0 6.0285.1941 6.0285 4.76004 0 4.8345-3.4419 4.8345-6.2 4.8345h-4.8412v3.2455h4.866c2.977 0 7.0803.0249 7.0803 4.9812 0 2.1645-1.6905 4.3741-3.117 4.6607l-.1422 3.4239c4.5637-.4288 7.7506-3.1598 7.7506-7.6941 0-5.8344-3.8798-6.859-5.234-7.2495z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5188 29.1019c-1.1443.3408-2.4511.3205-3.6473.3205-1.2958.003-2.5909-.0626-3.8798-.1964l-1.1962-.1715.0384-25.35289-7.41202-.09028v3.32682h2.97924v24.97365c1.0969.1716 2.68357.3409 4.39438.4627l1.221.0993c1.1895.0723 2.424.1219 3.6361.1219 1.3993 0 2.6926.0745 3.8662-.0699z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5136 31.8123-1.5686.571-1.4264.1422v-3.4239l1.5686-.9998 1.4264-2.4241z",
    fill: "url(#c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.2367 18.4537c0 2.5048-.5757 4.5197-1.7271 6.0448-1.1514 1.515-2.6967 2.2725-4.6359 2.2725-2.0705 0-3.6713-.7323-4.8025-2.1968l-.1363 1.8938h-2.5755v-23.27025h2.8027v8.68085c1.1312-1.4038 2.6916-2.10579 4.6813-2.10579s3.5501.75249 4.6813 2.25729c1.1413 1.5049 1.712 3.5653 1.712 6.1812zm-2.8028-.3182c0-1.9088-.3686-3.3834-1.1059-4.4237s-1.7978-1.5605-3.1815-1.5605c-1.8483 0-3.1764.8585-3.9844 2.5755v7.0902c.8585 1.717 2.1967 2.5755 4.0147 2.5755 1.3433 0 2.3887-.5202 3.1361-1.5605.7473-1.0403 1.121-2.6058 1.121-4.6965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.9019 24.8469c-1.0908 1.2827-2.6917 1.9241-4.8025 1.9241-1.7473 0-3.0805-.505-3.9996-1.515-.909-1.0201-1.3685-2.525-1.3787-4.5147v-10.6655h2.8028v10.5898c0 2.4846 1.01 3.7269 3.03 3.7269 2.1411 0 3.5652-.7979 4.2722-2.3937v-11.923h2.8028v16.3922h-2.6664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.5372 24.1804h9.5899v2.2876h-13.0138v-2.0604l9.0445-12.0139h-8.9081v-2.3179h12.4229v1.9846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.9295 24.1804h9.5895v2.2876h-13.0134v-2.0604l9.0445-12.0139h-8.9081v-2.3179h12.423v1.9846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.094 22.6654 4.06-12.5896h2.864l-5.878 16.3922h-2.137l-5.938-16.3922h2.863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.305 26.771c-2.222 0-4.03-.7272-5.424-2.1816-1.394-1.4645-2.091-3.4188-2.091-5.863v-.5151c0-1.6261.308-3.0754.924-4.348.627-1.2827 1.495-2.2826 2.606-2.9997 1.121-.7272 2.333-1.09079 3.636-1.09079 2.131 0 3.788.70199 4.969 2.10579 1.182 1.4039 1.773 3.4138 1.773 6.0297v1.1665h-11.105c.04 1.616.51 2.924 1.409 3.9239.909.9898 2.06 1.4847 3.454 1.4847.99 0 1.828-.202 2.515-.606s1.288-.9393 1.803-1.6059l1.712 1.3332c-1.374 2.1108-3.434 3.1663-6.181 3.1663zm-.349-14.6954c-1.131 0-2.08.4141-2.848 1.2423-.768.8181-1.242 1.9695-1.424 3.4542h8.211v-.2121c-.081-1.4241-.464-2.525-1.151-3.3027-.687-.7878-1.616-1.1817-2.788-1.1817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139 26.468h-2.803v-23.27025h2.803z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.3c2c264704de32411892dc9745df4910.svg";
export { ForwardRef as ReactComponent };